import { WORKOUT_KEY } from '../../../../../modules/workout/model'
import { WORKOUT_EXERCISE_KEY } from '../../../../workout-exercise/model'
import { WORKOUT_SECTION_KEY } from '../../../../workout-section/model'
import getWorkoutExercisesWorkoutSectionUtil from '../../../../workout-section/model/utils/get-workout-exercises'

function beforeSaveWorkoutHook (data) {
  const workoutSections = data[WORKOUT_KEY.WORKOUT_SECTIONS]
  if (!workoutSections) {
    return data
  }
  const updates = {
    [WORKOUT_KEY.WORKOUT_SECTIONS]: workoutSections.map(workoutSection => {
      const workoutExercises = getWorkoutExercisesWorkoutSectionUtil(
        workoutSection)
      return {
        ...workoutSection,
        [WORKOUT_SECTION_KEY.WORKOUT_EXERCISES]: workoutExercises.map(
          workoutExercise => {
            const setData = workoutExercise[WORKOUT_EXERCISE_KEY.SET_DATA]
            // If the setData was not changed, no-op
            if (!setData) {
              return workoutExercise
            }
            return {
              ...workoutExercise,
              [WORKOUT_EXERCISE_KEY.SET_DATA]: setData.map(set => {
                const newSet = { ...set }
                if (newSet.weight) {
                  newSet.weight = parseFloat(newSet.weight)
                }
                return newSet
              })
            }
          })
      }
    })
  }
  return {
    ...data, ...updates
  }
}

export default beforeSaveWorkoutHook
